import React from "react"
import "../css/layout.css"
import { IonBackButton, IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonImg, IonPage, IonTitle, IonToolbar } from "@ionic/react";

import { Link } from 'react-router-dom';

class F24HeaderF24 extends React.Component {

  getButtons(){
    const {buttons} = this.props;

    if (buttons)
      return(
        buttons.map(b => 
          <div className="home-buttons">
          <ul>
          <li><span></span></li>
            <li>
              <div onClick={() => b.action(b.context ? b.context : "")}>
                <img src={b.icon}/>
              </div>
            </li>
          </ul>
        </div>
          )
      )
  
      return ""
  }

  getIonicButtons(icon){
    const {buttons} = this.props;

    if (buttons)
      return(
        buttons.map((b ,i) => 
          <IonButton key={i} color='white' onClick={() => b.action(b.context ? b.context : "")}>
            {!icon && <IonImg className="headerImage" slot="end" src={b.icon} />}
            {icon  && <IonIcon icon={b.icon} slot="icon-only" color="primary"></IonIcon>}
          </IonButton>
          )
      )
  
      return ""
  }

  getLogo(){
    const {placement, fulllogo} = this.props;
    if (placement === 'main' || fulllogo )
      return (<IonImg slot="start" src="/assets/icon/f24/full_logo.svg"></IonImg>)
    else
      return (<IonImg slot="start" height="20px" src="/assets/icon/f24/logo.png"></IonImg>)
  }

  render(){
        const {placement, title, buttons} = this.props;

        //console.log("F24HEADER " + buttons);

        if (placement === "main"){
          return (
            <IonHeader mode="ios">
            <IonToolbar color="black" mode="ios">
               {this.getLogo()}
               <IonTitle style={{color: '#fff'}}>{title}</IonTitle>
               <IonButtons slot="end" >
                  {this.getIonicButtons()}
                 </IonButtons>
             </IonToolbar>
            </IonHeader>
          )
        }else{
          if (placement === "today"){
            return("")
            return (
              <IonHeader mode="ios">
              <IonToolbar color="black" mode="ios">
                 <IonTitle style={{color: '#fff'}}>{title}</IonTitle>
                 <IonButtons slot="end" >
                  {this.getIonicButtons()}
                 </IonButtons>
                 
               </IonToolbar>
              </IonHeader>
            )
          }
          return(
          <IonHeader mode="ios">
          <IonToolbar color="black" mode="ios">
             <IonButtons style={{color: '#fff'}} slot="start">
               <IonBackButton style={{color: '#fff'}} text=""  defaultHref="/" />
             </IonButtons>
             {this.getLogo()}
             <IonTitle style={{color: '#fff'}}>{title}</IonTitle>
             <IonButtons slot="end" >
              {this.getIonicButtons()}
            </IonButtons>
           </IonToolbar>
          </IonHeader>
          )
        }
    }
}

export default F24HeaderF24

/*            <button className="btnHamburger">
                <svg className="hamburger h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
            </button>
*/